<div *ngIf="modalData != ''">
    <div class="wrapper__header text-body-s" style="margin-left: var(--spacing-s); padding: var(--spacing-s)">
        <span> <b>Name:</b> {{ header.name }} | </span>
        <span> <b>Type:</b> {{ header.type }} </span>
    </div>
    <div [ngClass]="'row row-cols-4'" style="--grid-gutter-width: var(--spacing-s); padding: var(--spacing-s)">
        <div class="wrapper__card" *ngFor="let item of modalData">
            <div
                style="
                    box-shadow: var(--shadow-s);
                    background-color: #ffffff;
                    border-radius: var(--radius-medium);
                    margin: var(--spacing-xs);
                    padding: var(--spacing-xs);
                "
            >
                <div class="wrapper__card-container">
                    <div class="wrapper__card-landscape">
                        <img
                            class="image-landscape"
                            src="{{ item.bannerArt || item.albumArt || item.squareArt }}"
                            alt="bannerArt"
                        />
                    </div>
                </div>

                <div class="wrapper__card-text text-body-xs" style="padding: 10px; height: 70px">
                    <div class="ellipsis">Name: {{ item.name }}</div>
                    <div class="ellipsis">Source: {{ item.source }}</div>
                    <div class="ellipsis">WoiID: {{ item.woiId }}</div>
                </div>
            </div>
            <div class="modal-spinner-container" *ngIf="showSpinner">
                <app-spinner [isTable]="true"></app-spinner>
            </div>
        </div>
    </div>

    <div class="no-data-found" *ngIf="modalData == '' && dataFetched">
        <div class="no-data-found__text text-heading-m">No Data Found</div>
    </div>
</div>
